import React from "react";

const PrivacyPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="mb-6">Privacy Policy</h1>

      <div className="prose prose-lg max-w-none space-y-6">
        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            Introduction
          </h2>
          <p className="text-gray-600">
            This is an application created for tracking fitness activities. This
            privacy policy explains how we handle your data.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            Data Collection
          </h2>
          <p className="text-gray-600 mb-2">
            We collect and store the following information:
          </p>
          <ul className="list-disc list-inside text-gray-600 space-y-1 ml-4">
            <li>Email address (through Firebase Authentication)</li>
            <li>Profile information you provide (name, preferences)</li>
            <li>Workout, routine and exercise data you create</li>
            <li>Friend requests</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            Authentication & Cookies
          </h2>
          <p className="text-gray-600">
            We use Firebase Authentication to manage user accounts. Firebase
            uses cookies to maintain your logged-in session. These are essential
            for the app to function properly. We do not use tracking or
            advertising cookies.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            Data Storage & Visibility
          </h2>
          <ul className="list-disc list-inside text-gray-600 space-y-1 ml-4">
            <li>
              <span className="font-semibold">Privacy Controls</span>: By
              default, your personal fitness data is private.
            </li>
            <li>
              <span className="font-semibold">Social Features</span>: If you
              choose to use our social features (such as sharing routines or the
              activity feed), specific fitness and profile (email address and
              name) data will be visible to your approved friends.
            </li>
            <li>
              <span className="font-semibold">Third Parties</span>: We do not
              share your data with external third parties for marketing
              purposes.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            Data Security
          </h2>
          <p className="text-gray-600 mb-2">
            We implement industry-standard security measures including:
          </p>
          <ul className="list-disc list-inside text-gray-600 space-y-1 ml-4">
            <li>Firebase Authentication with secure password handling</li>
            <li>HTTPS encryption for all data transmission</li>
            <li>Rate limiting to prevent abuse</li>
            <li>Firestore security rules to protect your data</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            Your Rights
          </h2>
          <p className="text-gray-600 mb-2">You have the right to:</p>
          <ul className="list-disc list-inside text-gray-600 space-y-1 ml-4">
            <li>Access your personal data</li>
            <li>Update or correct your information</li>
            <li>Delete your account and all associated data</li>
          </ul>
          <p className="text-gray-600 mt-3">
            To exercise these rights or if you have questions, please{" "}
            <a href="/contact" className="text-blue-600 underline">
              contact us
            </a>
            .
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            Changes to This Policy
          </h2>
          <p className="text-gray-600">
            We may update this privacy policy from time to time. Continued use
            of the service after changes constitutes acceptance of the updated
            policy.
          </p>
        </section>

        <section>
          <p className="text-sm text-gray-500 mt-8">
            Last updated: February 2026
          </p>
        </section>
      </div>
    </div>
  );
};

export { PrivacyPage };
